<template>
  <div class="text-center">
    <PopupCommon
      v-model="snackbar"
      title="Powiadomienia"
      @close="snackbar = false"
      shadow
      :borderHeader="false"
      :borderFooter="false"
    >
      <template v-slot:content>
        <div
          class="list-item"
          v-for="item in messagesList"
          :key="item.messageId"
        >
          <div class="list-item-cont">
            <div class="notify-text pointer" @click="moveToNotification(item)">
              <div class="date-text mb-1 text-14">{{ dateText(item) }}</div>
              <div class="bold-500">{{ item.title }}</div>
            </div>
            <div>
              <v-btn
                color="primary"
                icon
                depressed
                outlined
                @click="removeItem(item)"
                :disabled="loading"
              >
                <v-icon size="18">mdi-trash-can-outline </v-icon>
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
        </div>
      </template>
      <template v-slot:footer>
        <v-btn
          color="primary"
          rounded
          outlined
          @click="removeAllItems"
          :disabled="!messagesCount"
        >
          <v-icon left>mdi-check</v-icon>
          Oznacz wszystkie jako przeczytane
        </v-btn>
        <v-btn
          color="primary"
          rounded
          @click="snackbar = false"
          depressed
          class="ml-0"
        >
          Zamknij
        </v-btn>
      </template>
    </PopupCommon>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import PopupCommon from "@/components/common/PopupCommon.vue";

export default {
  components: { PopupCommon },
  data: () => ({
    snackbar: false,
    loading: false
  }),
  computed: {
    ...mapGetters({
      messagesList: "auth/getMessagesList",
      messagesCount: "auth/getMessagesCount"
    }),
    areMessagesLoaded() {
      return this.$store.state.auth.messagesLoaded;
    }
  },
  watch: {
    areMessagesLoaded() {
      if (this.messagesList?.length > 0) {
        this.snackbar = true;
      }
    }
  },
  methods: {
    text(item) {
      return (
        item.title + " " + moment(item.sentDate).format("YYYY-MM-DD HH:mm")
      );
    },
    dateText(item) {
      return moment(item.sentDate).format("YYYY-MM-DD HH:mm");
    },
    removeAllItems() {
      this.loading = true;
      this.$axios
        .patch(`/v2/notification/mark-all-read`)
        .then(() => {})
        .catch(() => {
          this.$store.commit(
            "layout/showErrorDialog",
            "Nie udało się zapisać danych"
          );
        })
        .finally(() => {
          this.$store.dispatch("auth/getNotificationNews");
          this.loading = false;
          this.snackbar = false;
        });
    },
    async removeItem(item) {
      this.loading = true;
      this.$axios
        .put("/notification/receiving", item)
        .then(() => {})
        .catch(() => {
          this.$store.commit(
            "layout/showErrorDialog",
            "Nie udało się zapisać danych"
          );
        })
        .finally(() => {
          this.$store.dispatch("auth/getNotificationNews");
          this.loading = false;
        });
      if (this.messagesCount < 1) {
        this.loading = false;
        this.snackbar = false;
      }
    },
    async moveToNotification(noty) {
      const id = noty.messageId;
      this.snackbar = false;
      await this.$router.push({
        name: "AccountNotification",
        query: { id }
      });
    }
  },

  async created() {
    if (this.messagesCount > 0) {
      this.snackbar = true;
    } else this.snackbar = false;
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: 16px;
}

.date-text {
  opacity: 0.8;
}

.list-item-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
  gap: 10px;
  line-height: 1.4;
}
.v-list-item__content {
  color: #000000 !important;
}
.theme--dark.v-subheader {
  color: #000000 !important;
}
.v-list-item__title {
  color: #000000 !important;
}
.v-subheader {
  font-size: 1.4rem !important;
}
.border-bottom {
  border-bottom: 1px solid #eee;
}

.notify-text {
  &:hover {
    color: var(--c-primary-purple);
  }
}
</style>
